import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { countryInterceptor } from './interceptors/country.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { NgxMetaPixelModule } from 'ngx-meta-pixel';
import { environment } from './environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideHttpClient(withInterceptors([authInterceptor, countryInterceptor])), provideAnimationsAsync(),
    provideAnimations(), 
    provideToastr({preventDuplicates:true, timeOut:3000}),
    importProvidersFrom(
      NgxMetaPixelModule.forRoot({
        enabled: environment.production,
        pathToMetaPixelHtml: 'assets/meta-pixel.html',
      }),
    ),
    provideTranslateService({ defaultLanguage: 'es' }),
    provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
  ]
};
